import {Component, Inject} from '@angular/core';
import {Project} from '../../model';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';
import {AutocompleteMixin} from './autocomplete.mixin';

@Component({
  template: `
    <h1 mat-dialog-title>{{title}}</h1>
    <mat-dialog-content>
      <mat-form-field appearance="fill" class="col-2_3">
        <mat-label>Projekt wählen</mat-label>
        <input name="extern" matInput [formControl]="autocomplete.formControl" [matAutocomplete]="auto">
        <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayEntry"
                          (optionSelected)="entry=$event.option.value">
          <mat-option *ngFor="let entry of autocomplete.entries | async" [value]="entry">
            <span style="display: inline-block; width: 6em">{{entry.nr}}</span>
            {{entry.title}}
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>
      <button mat-raised-button color="primary" [mat-dialog-close]="entry" [disabled]="!entry">
        <mat-icon>done</mat-icon>
        Auswählen
      </button>
    </mat-dialog-content>
  `
})
export class ProjectSelectDialogComponent {
  title: string;
  entry: Project;
  autocomplete: AutocompleteMixin<Project>;

  constructor(@Inject(MAT_DIALOG_DATA) {title, entries}: any) {
    this.title = title;
    this.autocomplete = new AutocompleteMixin(
      entries,
      (entry, search) =>
        entry.nr?.toLowerCase().includes(search) || entry.title?.toLowerCase().includes(search)
    );
  }

  displayEntry(entry: Project): string {
    return entry ? (entry.nr as string + ' | ' + entry.title as string) : '';
  }
}
